import React from "react";
import { Box } from "@mui/material";

const RecordCard = ({ children, highlight = false, sx = {} }) => (
  <Box
    sx={{
      borderRadius: 1.5,
      border: "1px solid",
      borderColor: highlight ? "primary.main" : "divider",
      p: 1.1,
      mb: 1,
      bgcolor: highlight
        ? (theme) => (theme.palette.mode === "dark" ? "rgba(25,118,210,0.12)" : "rgba(25,118,210,0.06)")
        : "transparent",
      transition: "border-color 0.15s ease, box-shadow 0.15s ease",
      "&:hover": { borderColor: "primary.main", boxShadow: "0 2px 10px rgba(0,0,0,0.06)" },
      "&:last-of-type": { mb: 0 },
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default RecordCard;